module.exports = __webpack_public_path__ + "img/merrithew.0412d697.png";